import { render, staticRenderFns } from "./printAndClickRecord.vue?vue&type=template&id=7e223e10&scoped=true"
import script from "./printAndClickRecord.vue?vue&type=script&lang=js"
export * from "./printAndClickRecord.vue?vue&type=script&lang=js"
import style0 from "./printAndClickRecord.vue?vue&type=style&index=0&id=7e223e10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e223e10",
  null
  
)

export default component.exports